/**
 * Priority bands, by what a call actually costs. A provider that is usually
 * free but sometimes metered must declare its **worst case**: priorities are
 * planned before execution, so the safe early exit would otherwise skip a rule
 * assuming a free call it cannot make.
 */
export const CostBand = {
    /** Local data or a cached response. Effectively free. */
    LOCAL: 0,
    /** Live call against an unmetered source. */
    UNMETERED: 100,
    /**
     * Live call that spends an allowance or costs money — KRD's checks. MF was
     * here for a documented daily cap until 2026-09-25, when production measured
     * that cap as not enforced.
     */
    METERED: 200,
};
/**
 * Only the coverage list is needed, so the parameter is that and nothing more —
 * a full `ProviderDescriptor` satisfies it, and so does the back office's own
 * provider shape (whose `worstCaseCost` is a plain number). One coverage test,
 * shared, rather than the panel re-writing it and risking a different answer to
 * "does this source serve DE" than the engine's.
 */
export function coversCountry(source, country) {
    return source.countries === "all" || source.countries.includes(country);
}
//# sourceMappingURL=provider.js.map